











import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import envInvoiceVue from "./envInvoice.vue"
import envDayAccountVue from "./envDayAccount.vue"
import envOthersVue from "./envOthers.vue"
import enPaySheetsVue from "./enPaySheets.vue"

@Component({
    components: {
        "invoice": envInvoiceVue,
        "dayAccount": envDayAccountVue,
        "other": envOthersVue,
        "paySheets": enPaySheetsVue
    }
})
export default class envidence extends Vue {
    @Prop({ type: Boolean })
    visible: any;

    @Prop({ type: [Object, Array] })
    data: any;

    show: boolean = this.visible;

    mounted() {
        
    }

    @Watch("visible")
    visibleChange(val: boolean) {
        this.show = val;
    }

    @Watch("show")
    showChange(val: boolean) {
        this.$emit("update:visible", val);
    }
}
